import styled from 'styled-components'

export const StyledNewsAlertStatusToggleButton = styled.div`
  input[type='checkbox']:hover {
    background-color: #1677ff;
  }
`
